var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "94", height: "94", viewBox: "0 0 94 94", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Group 9"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { x: "-38.3%", y: "-38.3%", width: "176.7%", height: "176.7%", filterUnits: "objectBoundingBox", id: "filter-1" },
        React.createElement("feOffset", { dy: "4", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "4", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0", "in": "shadowBlurOuter1", result: "shadowMatrixOuter1" }),
        React.createElement(
          "feMerge",
          null,
          React.createElement("feMergeNode", { "in": "shadowMatrixOuter1" }),
          React.createElement("feMergeNode", { "in": "SourceGraphic" })
        )
      )
    ),
    React.createElement(
      "g",
      { id: "Boost-&-incognito-in-line-promo", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "Web---Incognito-top-banner", transform: "translate(-269 -8)" },
        React.createElement(
          "g",
          { id: "Group-9", filter: "url(#filter-1)", transform: "translate(286 25)" },
          React.createElement("circle", { id: "Oval", fill: "#1A1A1A", cx: "30", cy: "30", r: "30" }),
          React.createElement(
            "g",
            { id: "noun_mask_822988", transform: "translate(10.588 24.706)", fill: "#FFF", fillRule: "nonzero" },
            React.createElement("path", { d: "M37.352.065s-2.735 1.684-6.706 1.243C26.676.867 23.466.073 19.468 5.19 15.47.072 12.26.866 8.289 1.308 4.319 1.748 1.583.065 1.583.065-.535 5.175-.186 9.866 3.789 13.13c6.002 4.93 15.679-2.912 15.679-2.912s9.676 7.842 15.678 2.912C39.12 9.866 39.47 5.174 37.352.065zm-26.238 9.89c-2.998 0-5.649-3.892-5.649-3.892 1.412 1.138 3.177.186 5.649.01 2.472-.177 4.94 2.143 4.94 2.143s-1.942 1.739-4.94 1.739zm16.707 0c-2.998 0-4.94-1.74-4.94-1.74s2.467-2.319 4.94-2.143c2.472.177 4.237 1.128 5.648-.01 0 0-2.65 3.893-5.648 3.893z", id: "Shape" })
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Incognito/badge.svg